module.exports = __webpack_public_path__ + "static/media/mov.512f47eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/scenes/Files/images/mov.svg
// module id = 600
// module chunks = 0